export const normalizeFileExtension = (filename: string): string => {
  const lastDotIndex = filename.lastIndexOf(".");
  if (lastDotIndex === -1 || lastDotIndex === 0) {
    return filename;
  }
  const namePart = filename.slice(0, lastDotIndex);
  const extPart = filename.slice(lastDotIndex).toLowerCase();
  return namePart + extPart;
};
